export const ChartIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6028_17543" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6028_17543)">
        <path d="M8.40394 8.39382L7.49434 6.40924L5.50974 5.49964L7.49434 4.59005L8.40394 2.60547L9.31354 4.59005L11.2981 5.49964L9.31354 6.40924L8.40394 8.39382ZM14.9039 11.3938L14.1458 9.75779L12.5097 8.99965L14.1458 8.2415L14.9039 6.60547L15.6621 8.2415L17.2981 8.99965L15.6621 9.75779L14.9039 11.3938ZM3.90394 13.3938L3.14577 11.7578L1.50977 10.9996L3.14577 10.2415L3.90394 8.60547L4.66209 10.2415L6.29812 10.9996L4.66209 11.7578L3.90394 13.3938ZM4.36547 20.1535L3.25012 19.0381L10.4039 11.8843L14.4039 15.8843L21.4462 7.89967L22.5001 8.93427L14.4232 18.1342L10.4039 14.115L4.36547 20.1535Z" fill="black" fillOpacity="0.4" />
      </g>
    </svg>
  );
};
export const ChartActive = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6028_17543" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6028_17543)">
        <path d="M8.40394 8.39382L7.49434 6.40924L5.50974 5.49964L7.49434 4.59005L8.40394 2.60547L9.31354 4.59005L11.2981 5.49964L9.31354 6.40924L8.40394 8.39382ZM14.9039 11.3938L14.1458 9.75779L12.5097 8.99965L14.1458 8.2415L14.9039 6.60547L15.6621 8.2415L17.2981 8.99965L15.6621 9.75779L14.9039 11.3938ZM3.90394 13.3938L3.14577 11.7578L1.50977 10.9996L3.14577 10.2415L3.90394 8.60547L4.66209 10.2415L6.29812 10.9996L4.66209 11.7578L3.90394 13.3938ZM4.36547 20.1535L3.25012 19.0381L10.4039 11.8843L14.4039 15.8843L21.4462 7.89967L22.5001 8.93427L14.4232 18.1342L10.4039 14.115L4.36547 20.1535Z" fill="#0040FF" fillOpacity="1" />
      </g>
    </svg>
  );
};
export const CameraActiveIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0)">
        <path d="M4.54791 19.5C4.04278 19.5 3.61521 19.325 3.26521 18.975C2.91523 18.625 2.74023 18.1974 2.74023 17.6923V6.3077C2.74023 5.80257 2.91523 5.375 3.26521 5.025C3.61521 4.675 4.04278 4.5 4.54791 4.5H15.9325C16.4376 4.5 16.8652 4.675 17.2152 5.025C17.5652 5.375 17.7402 5.80257 17.7402 6.3077V10.8846L21.2593 7.36543V16.6345L17.7402 13.1153V17.6923C17.7402 18.1974 17.5652 18.625 17.2152 18.975C16.8652 19.325 16.4376 19.5 15.9325 19.5H4.54791ZM4.54791 18H15.9325C16.0222 18 16.096 17.9711 16.1536 17.9134C16.2113 17.8557 16.2402 17.782 16.2402 17.6923V6.3077C16.2402 6.21795 16.2113 6.14423 16.1536 6.08652C16.096 6.02882 16.0222 5.99998 15.9325 5.99998H4.54791C4.45816 5.99998 4.38443 6.02882 4.32673 6.08652C4.26903 6.14423 4.24018 6.21795 4.24018 6.3077V17.6923C4.24018 17.782 4.26903 17.8557 4.32673 17.9134C4.38443 17.9711 4.45816 18 4.54791 18ZM10.2402 15.5192L11.3363 13.0961L13.7594 12L11.3363 10.9038L10.2402 8.48078L9.14403 10.9038L6.72098 12L9.14403 13.0961L10.2402 15.5192Z" fill="#0040FF" fillOpacity="1" />
      </g>
    </svg>
  );
};

export const CameraIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0)">
        <path d="M4.54791 19.5C4.04278 19.5 3.61521 19.325 3.26521 18.975C2.91523 18.625 2.74023 18.1974 2.74023 17.6923V6.3077C2.74023 5.80257 2.91523 5.375 3.26521 5.025C3.61521 4.675 4.04278 4.5 4.54791 4.5H15.9325C16.4376 4.5 16.8652 4.675 17.2152 5.025C17.5652 5.375 17.7402 5.80257 17.7402 6.3077V10.8846L21.2593 7.36543V16.6345L17.7402 13.1153V17.6923C17.7402 18.1974 17.5652 18.625 17.2152 18.975C16.8652 19.325 16.4376 19.5 15.9325 19.5H4.54791ZM4.54791 18H15.9325C16.0222 18 16.096 17.9711 16.1536 17.9134C16.2113 17.8557 16.2402 17.782 16.2402 17.6923V6.3077C16.2402 6.21795 16.2113 6.14423 16.1536 6.08652C16.096 6.02882 16.0222 5.99998 15.9325 5.99998H4.54791C4.45816 5.99998 4.38443 6.02882 4.32673 6.08652C4.26903 6.14423 4.24018 6.21795 4.24018 6.3077V17.6923C4.24018 17.782 4.26903 17.8557 4.32673 17.9134C4.38443 17.9711 4.45816 18 4.54791 18ZM10.2402 15.5192L11.3363 13.0961L13.7594 12L11.3363 10.9038L10.2402 8.48078L9.14403 10.9038L6.72098 12L9.14403 13.0961L10.2402 15.5192Z" fill="black" fillOpacity="0.4" />
      </g>
    </svg>
  );
};
export const MapIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6028_17553" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6028_17553)">
        <path d="M8.25385 16.5961L12 14.8961L15.7461 16.5961L16.0057 16.3365L12 6.65388L7.99423 16.3365L8.25385 16.5961ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76664 19.225 7.87498 17.675 6.32498C16.125 4.77498 14.2333 3.99998 12 3.99998C9.76664 3.99998 7.87498 4.77498 6.32498 6.32498C4.77498 7.87498 3.99998 9.76664 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20Z" fill="black" fillOpacity="0.4" />
      </g>
    </svg>
  );
};
export const MapActiveIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6028_17553" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6028_17553)">
        <path d="M8.25385 16.5961L12 14.8961L15.7461 16.5961L16.0057 16.3365L12 6.65388L7.99423 16.3365L8.25385 16.5961ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76664 19.225 7.87498 17.675 6.32498C16.125 4.77498 14.2333 3.99998 12 3.99998C9.76664 3.99998 7.87498 4.77498 6.32498 6.32498C4.77498 7.87498 3.99998 9.76664 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20Z" fill="#0040FF" fillOpacity="1" />
      </g>
    </svg>
  );
};
export const VideoIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6028_17558" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6028_17558)">
        <path d="M3.29883 17.3077V6.69238L11.2603 12L3.29883 17.3077ZM12.7411 17.3077V6.69238L20.7026 12L12.7411 17.3077ZM4.7988 14.5001L8.5642 12L4.7988 9.50001V14.5001ZM14.2411 14.5001L18.0065 12L14.2411 9.50001V14.5001Z" fill="black" fillOpacity="0.4" />
      </g>
    </svg>
  );
};
export const VideoActiveIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6028_17558" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6028_17558)">
        <path d="M3.29883 17.3077V6.69238L11.2603 12L3.29883 17.3077ZM12.7411 17.3077V6.69238L20.7026 12L12.7411 17.3077ZM4.7988 14.5001L8.5642 12L4.7988 9.50001V14.5001ZM14.2411 14.5001L18.0065 12L14.2411 9.50001V14.5001Z" fill="#0040FF" fillOpacity="1" />
      </g>
    </svg>
  );
};
export const CPUIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6028_17563" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6028_17563)">
        <path d="M4.42291 20.5C3.91779 20.5 3.49023 20.325 3.14023 19.975C2.79023 19.625 2.61523 19.1974 2.61523 18.6923V5.3077C2.61523 4.80257 2.79023 4.375 3.14023 4.025C3.49023 3.675 3.91779 3.5 4.42291 3.5H17.8075C18.3126 3.5 18.7402 3.675 19.0902 4.025C19.4402 4.375 19.6152 4.80257 19.6152 5.3077V7.38463H21.3844V8.88458H19.6152V11.25H21.3844V12.75H19.6152V15.1154H21.3844V16.6153H19.6152V18.6923C19.6152 19.1974 19.4402 19.625 19.0902 19.975C18.7402 20.325 18.3126 20.5 17.8075 20.5H4.42291ZM4.42291 19H17.8075C17.8844 19 17.9549 18.9679 18.019 18.9038C18.0832 18.8397 18.1152 18.7692 18.1152 18.6923V5.3077C18.1152 5.23077 18.0832 5.16024 18.019 5.09613C17.9549 5.03203 17.8844 4.99998 17.8075 4.99998H4.42291C4.34599 4.99998 4.27548 5.03203 4.21136 5.09613C4.14726 5.16024 4.11521 5.23077 4.11521 5.3077V18.6923C4.11521 18.7692 4.14726 18.8397 4.21136 18.9038C4.27548 18.9679 4.34599 19 4.42291 19ZM6.49983 16.6153H11.019V13.0961H6.49983V16.6153ZM12.2114 9.90383H15.7306V7.38463H12.2114V9.90383ZM6.49983 11.9038H11.019V7.38463H6.49983V11.9038ZM12.2114 16.6153H15.7306V11.0961H12.2114V16.6153Z" fill="black" fillOpacity="0.4" />
      </g>
    </svg>
  );
};
export const CPUActiveIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6028_17563" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6028_17563)">
        <path d="M4.42291 20.5C3.91779 20.5 3.49023 20.325 3.14023 19.975C2.79023 19.625 2.61523 19.1974 2.61523 18.6923V5.3077C2.61523 4.80257 2.79023 4.375 3.14023 4.025C3.49023 3.675 3.91779 3.5 4.42291 3.5H17.8075C18.3126 3.5 18.7402 3.675 19.0902 4.025C19.4402 4.375 19.6152 4.80257 19.6152 5.3077V7.38463H21.3844V8.88458H19.6152V11.25H21.3844V12.75H19.6152V15.1154H21.3844V16.6153H19.6152V18.6923C19.6152 19.1974 19.4402 19.625 19.0902 19.975C18.7402 20.325 18.3126 20.5 17.8075 20.5H4.42291ZM4.42291 19H17.8075C17.8844 19 17.9549 18.9679 18.019 18.9038C18.0832 18.8397 18.1152 18.7692 18.1152 18.6923V5.3077C18.1152 5.23077 18.0832 5.16024 18.019 5.09613C17.9549 5.03203 17.8844 4.99998 17.8075 4.99998H4.42291C4.34599 4.99998 4.27548 5.03203 4.21136 5.09613C4.14726 5.16024 4.11521 5.23077 4.11521 5.3077V18.6923C4.11521 18.7692 4.14726 18.8397 4.21136 18.9038C4.27548 18.9679 4.34599 19 4.42291 19ZM6.49983 16.6153H11.019V13.0961H6.49983V16.6153ZM12.2114 9.90383H15.7306V7.38463H12.2114V9.90383ZM6.49983 11.9038H11.019V7.38463H6.49983V11.9038ZM12.2114 16.6153H15.7306V11.0961H12.2114V16.6153Z" fill="#0040FF" fillOpacity="1" />
      </g>
    </svg>
  );
};
export const PeopleIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6028_17573" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6028_17573)">
        <path d="M4.99997 18.0423C5.89998 17.159 6.94581 16.4631 8.13748 15.9548C9.32914 15.4465 10.6166 15.1923 12 15.1923C13.3833 15.1923 14.6708 15.4465 15.8625 15.9548C17.0541 16.4631 18.1 17.159 19 18.0423V5.3077C19 5.23077 18.9679 5.16024 18.9038 5.09613C18.8397 5.03203 18.7692 4.99998 18.6923 4.99998H5.3077C5.23077 4.99998 5.16024 5.03203 5.09612 5.09613C5.03202 5.16024 4.99997 5.23077 4.99997 5.3077V18.0423ZM12 13.0385C12.9025 13.0385 13.6698 12.7224 14.3019 12.0904C14.9339 11.4583 15.25 10.691 15.25 9.78845C15.25 8.8859 14.9339 8.1186 14.3019 7.48655C13.6698 6.8545 12.9025 6.53848 12 6.53848C11.0974 6.53848 10.3301 6.8545 9.69808 7.48655C9.06603 8.1186 8.75 8.8859 8.75 9.78845C8.75 10.691 9.06603 11.4583 9.69808 12.0904C10.3301 12.7224 11.0974 13.0385 12 13.0385ZM5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.3077C3.5 4.80257 3.675 4.375 4.025 4.025C4.375 3.675 4.80257 3.5 5.3077 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80257 20.5 5.3077V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.3077ZM6.44225 19H17.5577V18.7885C16.768 18.0833 15.9016 17.5577 14.9587 17.2115C14.0157 16.8653 13.0295 16.6923 12 16.6923C10.9833 16.6923 10.0019 16.8637 9.05573 17.2067C8.10956 17.5497 7.2384 18.0705 6.44225 18.7692V19ZM12 11.5385C11.5192 11.5385 11.1073 11.367 10.7644 11.0241C10.4214 10.6811 10.25 10.2692 10.25 9.78845C10.25 9.30768 10.4214 8.89583 10.7644 8.55288C11.1073 8.20993 11.5192 8.03845 12 8.03845C12.4807 8.03845 12.8926 8.20993 13.2356 8.55288C13.5785 8.89583 13.75 9.30768 13.75 9.78845C13.75 10.2692 13.5785 10.6811 13.2356 11.0241C12.8926 11.367 12.4807 11.5385 12 11.5385Z" fill="black" fillOpacity="0.4" />
      </g>
    </svg>
  );
};
export const SearchIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4119_36175)">
        <path
          d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 21L15 15"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4119_36175">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FilterIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4119_36174)">
        <path
          d="M6 12C7.10457 12 8 11.1046 8 10C8 8.89543 7.10457 8 6 8C4.89543 8 4 8.89543 4 10C4 11.1046 4.89543 12 6 12Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 4V8"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 12V20"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 4V14"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 18V20"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 9C19.1046 9 20 8.10457 20 7C20 5.89543 19.1046 5 18 5C16.8954 5 16 5.89543 16 7C16 8.10457 16.8954 9 18 9Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 4V5"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 9V20"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4119_36174">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SettingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4472_3896)">
        <path
          d="M10.325 4.317C10.751 2.561 13.249 2.561 13.675 4.317C13.7389 4.5808 13.8642 4.82578 14.0407 5.032C14.2172 5.23822 14.4399 5.39985 14.6907 5.50375C14.9414 5.60764 15.2132 5.65085 15.4838 5.62987C15.7544 5.60889 16.0162 5.5243 16.248 5.383C17.791 4.443 19.558 6.209 18.618 7.753C18.4769 7.98466 18.3924 8.24634 18.3715 8.51677C18.3506 8.78721 18.3938 9.05877 18.4975 9.30938C18.6013 9.55999 18.7627 9.78258 18.9687 9.95905C19.1747 10.1355 19.4194 10.2609 19.683 10.325C21.439 10.751 21.439 13.249 19.683 13.675C19.4192 13.7389 19.1742 13.8642 18.968 14.0407C18.7618 14.2172 18.6001 14.4399 18.4963 14.6907C18.3924 14.9414 18.3491 15.2132 18.3701 15.4838C18.3911 15.7544 18.4757 16.0162 18.617 16.248C19.557 17.791 17.791 19.558 16.247 18.618C16.0153 18.4769 15.7537 18.3924 15.4832 18.3715C15.2128 18.3506 14.9412 18.3938 14.6906 18.4975C14.44 18.6013 14.2174 18.7627 14.0409 18.9687C13.8645 19.1747 13.7391 19.4194 13.675 19.683C13.249 21.439 10.751 21.439 10.325 19.683C10.2611 19.4192 10.1358 19.1742 9.95929 18.968C9.7828 18.7618 9.56011 18.6001 9.30935 18.4963C9.05859 18.3924 8.78683 18.3491 8.51621 18.3701C8.24559 18.3911 7.98375 18.4757 7.752 18.617C6.209 19.557 4.442 17.791 5.382 16.247C5.5231 16.0153 5.60755 15.7537 5.62848 15.4832C5.64942 15.2128 5.60624 14.9412 5.50247 14.6906C5.3987 14.44 5.23726 14.2174 5.03127 14.0409C4.82529 13.8645 4.58056 13.7391 4.317 13.675C2.561 13.249 2.561 10.751 4.317 10.325C4.5808 10.2611 4.82578 10.1358 5.032 9.95929C5.23822 9.7828 5.39985 9.56011 5.50375 9.30935C5.60764 9.05859 5.65085 8.78683 5.62987 8.51621C5.60889 8.24559 5.5243 7.98375 5.383 7.752C4.443 6.209 6.209 4.442 7.753 5.382C8.753 5.99 10.049 5.452 10.325 4.317Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4472_3896">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FullScreenIcon = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4472_3914)">
        <path
          d="M4 8V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 16V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H8"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V8"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V16"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4472_3914">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SmallMenuIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4472_13435)">
        <path
          d="M18 10H14V6"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 4L14 10"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 14H10V18"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 14L4 20"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4472_13435">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DownIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4472_4279)">
        <path d="M7 9L12 15L17 9H7Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_4472_4279">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const BellIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4472_4270)">
        <path
          d="M10 5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5C15.1484 5.54303 16.1274 6.38833 16.8321 7.4453C17.5367 8.50227 17.9404 9.73107 18 11V14C18.0753 14.6217 18.2954 15.2171 18.6428 15.7381C18.9902 16.2592 19.4551 16.6914 20 17H4C4.54494 16.6914 5.00981 16.2592 5.35719 15.7381C5.70457 15.2171 5.92474 14.6217 6 14V11C6.05956 9.73107 6.4633 8.50227 7.16795 7.4453C7.8726 6.38833 8.85159 5.54303 10 5"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 17V18C9 18.7956 9.31607 19.5587 9.87868 20.1213C10.4413 20.6839 11.2044 21 12 21C12.7956 21 13.5587 20.6839 14.1213 20.1213C14.6839 19.5587 15 18.7956 15 18V17"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="17" cy="7" r="3.5" fill="#F25B60" stroke="white" />
      </g>
      <defs>
        <clipPath id="clip0_4472_4270">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DownIcons = ({ color = "black" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4472_13009)">
        <path
          d="M5 7.5L10 12.5L15 7.5"
          stroke={color}
          strokeOpacity="1"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4472_13009">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ZoomIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4501_15045)">
        <path
          d="M16 4H20V8"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 10L20 4"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 20H4V16"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 20L10 14"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4501_15045">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const LeftIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4501_19276)">
        <path d="M9 17L15 12L9 7L9 17Z" fill="black" fillOpacity="0.4" />
      </g>
      <defs>
        <clipPath id="clip0_4501_19276">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 24) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const MenuIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4568_20140)">
        <path
          d="M10.0003 10.8334C10.4606 10.8334 10.8337 10.4603 10.8337 10.0001C10.8337 9.53984 10.4606 9.16675 10.0003 9.16675C9.54009 9.16675 9.16699 9.53984 9.16699 10.0001C9.16699 10.4603 9.54009 10.8334 10.0003 10.8334Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0003 16.6667C10.4606 16.6667 10.8337 16.2936 10.8337 15.8333C10.8337 15.3731 10.4606 15 10.0003 15C9.54009 15 9.16699 15.3731 9.16699 15.8333C9.16699 16.2936 9.54009 16.6667 10.0003 16.6667Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0003 4.99992C10.4606 4.99992 10.8337 4.62682 10.8337 4.16659C10.8337 3.70635 10.4606 3.33325 10.0003 3.33325C9.54009 3.33325 9.16699 3.70635 9.16699 4.16659C9.16699 4.62682 9.54009 4.99992 10.0003 4.99992Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4568_20140">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FullVideo = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4568_20134)">
        <path
          d="M13.333 3.33325H16.6663V6.66659"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.667 8.33325L16.667 3.33325"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66634 16.6666H3.33301V13.3333"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33301 16.6667L8.33301 11.6667"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4568_20134">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Previous = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4578_20418)">
        <path
          d="M15.5 6L9.5 12L15.5 18"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4578_20418">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Next = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4578_20446)">
        <path
          d="M9.5 18L15.5 12L9.5 6"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4578_20446">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(24.5 24) rotate(-180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Close = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4600_19981)">
        <path
          d="M15 5L5 15"
          stroke={color ? color : "black"}

          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 5L15 15"
          stroke={color ? color : "black"}

          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4600_19981">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const UserIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        fill="#0040FF"
      />
      <path
        d="M12.0002 14.5C6.99016 14.5 2.91016 17.86 2.91016 22C2.91016 22.28 3.13016 22.5 3.41016 22.5H20.5902C20.8702 22.5 21.0902 22.28 21.0902 22C21.0902 17.86 17.0102 14.5 12.0002 14.5Z"
        fill="#0040FF"
      />
    </svg>
  );
};
export const UserIconSolid = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 20" fill="none">
      <mask id="mask0_6141_29272" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6141_29272)">
        <path d="M6.02308 17.2923C6.87308 16.6615 7.79903 16.1635 8.80095 15.7981C9.80287 15.4327 10.8692 15.25 12 15.25C13.1307 15.25 14.1971 15.4327 15.199 15.7981C16.2009 16.1635 17.1269 16.6615 17.9769 17.2923C18.5987 16.609 19.0913 15.8179 19.4548 14.9192C19.8182 14.0205 20 13.0474 20 12C20 9.78331 19.2208 7.89581 17.6625 6.33748C16.1041 4.77914 14.2166 3.99998 12 3.99998C9.78331 3.99998 7.89581 4.77914 6.33748 6.33748C4.77914 7.89581 3.99998 9.78331 3.99998 12C3.99998 13.0474 4.18171 14.0205 4.54518 14.9192C4.90864 15.8179 5.40128 16.609 6.02308 17.2923ZM12.0003 12.75C11.0873 12.75 10.3173 12.4366 9.69038 11.8099C9.06346 11.1831 8.75 10.4133 8.75 9.50028C8.75 8.58726 9.06336 7.81729 9.69008 7.19038C10.3168 6.56346 11.0867 6.25 11.9997 6.25C12.9127 6.25 13.6827 6.56336 14.3096 7.19008C14.9365 7.81681 15.25 8.58668 15.25 9.49968C15.25 10.4127 14.9366 11.1827 14.3099 11.8096C13.6831 12.4365 12.9133 12.75 12.0003 12.75ZM12 21.5C10.6807 21.5 9.44325 21.2519 8.2875 20.7557C7.13173 20.2596 6.12628 19.5839 5.27115 18.7288C4.41603 17.8737 3.7404 16.8682 3.24425 15.7125C2.74808 14.5567 2.5 13.3192 2.5 12C2.5 10.6807 2.74808 9.44325 3.24425 8.2875C3.7404 7.13173 4.41603 6.12628 5.27115 5.27115C6.12628 4.41603 7.13173 3.7404 8.2875 3.24425C9.44325 2.74808 10.6807 2.5 12 2.5C13.3192 2.5 14.5567 2.74808 15.7125 3.24425C16.8682 3.7404 17.8737 4.41603 18.7288 5.27115C19.5839 6.12628 20.2596 7.13173 20.7557 8.2875C21.2519 9.44325 21.5 10.6807 21.5 12C21.5 13.3192 21.2519 14.5567 20.7557 15.7125C20.2596 16.8682 19.5839 17.8737 18.7288 18.7288C17.8737 19.5839 16.8682 20.2596 15.7125 20.7557C14.5567 21.2519 13.3192 21.5 12 21.5ZM12 20C12.9025 20 13.7727 19.8548 14.6105 19.5644C15.4484 19.274 16.1923 18.8679 16.8423 18.3461C16.1923 17.8436 15.458 17.4519 14.6394 17.1711C13.8208 16.8903 12.941 16.75 12 16.75C11.0589 16.75 10.1775 16.8887 9.35573 17.1663C8.53393 17.4439 7.80123 17.8371 7.15765 18.3461C7.80765 18.8679 8.55157 19.274 9.3894 19.5644C10.2272 19.8548 11.0974 20 12 20ZM12 11.25C12.4974 11.25 12.9134 11.0827 13.2481 10.7481C13.5827 10.4134 13.75 9.99741 13.75 9.49998C13.75 9.00254 13.5827 8.58651 13.2481 8.25188C12.9134 7.91726 12.4974 7.74995 12 7.74995C11.5025 7.74995 11.0865 7.91726 10.7519 8.25188C10.4173 8.58651 10.25 9.00254 10.25 9.49998C10.25 9.99741 10.4173 10.4134 10.7519 10.7481C11.0865 11.0827 11.5025 11.25 12 11.25Z" fill="#0040FF" />
      </g>
    </svg>
  );
};
export const PasswordIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 8V10.1C18.31 10.04 17.81 10.01 17.25 10V8C17.25 4.85 16.36 2.75 12 2.75C7.64 2.75 6.75 4.85 6.75 8V10C6.19 10.01 5.69 10.04 5.25 10.1V8C5.25 5.1 5.95 1.25 12 1.25C18.05 1.25 18.75 5.1 18.75 8Z"
        fill="#0040FF"
      />
      <path
        d="M18.75 10.1C18.31 10.04 17.81 10.01 17.25 10H6.75C6.19 10.01 5.69 10.04 5.25 10.1C2.7 10.41 2 11.66 2 15V17C2 21 3 22 7 22H17C21 22 22 21 22 17V15C22 11.66 21.3 10.41 18.75 10.1ZM8.71 16.71C8.52 16.89 8.26 17 8 17C7.87 17 7.74 16.97 7.62 16.92C7.49 16.87 7.39 16.8 7.29 16.71C7.11 16.52 7 16.26 7 16C7 15.87 7.03 15.74 7.08 15.62C7.13 15.5 7.2 15.39 7.29 15.29C7.39 15.2 7.49 15.13 7.62 15.08C7.99 14.92 8.43 15.01 8.71 15.29C8.8 15.39 8.87 15.5 8.92 15.62C8.97 15.74 9 15.87 9 16C9 16.26 8.89 16.52 8.71 16.71ZM12.92 16.38C12.87 16.5 12.8 16.61 12.71 16.71C12.52 16.89 12.26 17 12 17C11.73 17 11.48 16.89 11.29 16.71C11.2 16.61 11.13 16.5 11.08 16.38C11.03 16.26 11 16.13 11 16C11 15.73 11.11 15.48 11.29 15.29C11.66 14.92 12.33 14.92 12.71 15.29C12.89 15.48 13 15.73 13 16C13 16.13 12.97 16.26 12.92 16.38ZM16.71 16.71C16.52 16.89 16.26 17 16 17C15.74 17 15.48 16.89 15.29 16.71C15.11 16.52 15 16.27 15 16C15 15.73 15.11 15.48 15.29 15.29C15.67 14.92 16.34 14.92 16.71 15.29C16.75 15.34 16.79 15.39 16.83 15.45C16.87 15.5 16.9 15.56 16.92 15.62C16.95 15.68 16.97 15.74 16.98 15.8C16.99 15.87 17 15.94 17 16C17 16.26 16.89 16.52 16.71 16.71Z"
        fill="#0040FF"
      />
    </svg>
  );
};
export const PasswordIconSolid = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6141_16585" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6141_16585)">
        <path d="M6.3077 21.4999C5.80898 21.4999 5.38302 21.3233 5.02982 20.9701C4.67661 20.6169 4.5 20.1909 4.5 19.6922V10.3077C4.5 9.80893 4.67661 9.38297 5.02982 9.02977C5.38302 8.67656 5.80898 8.49995 6.3077 8.49995H7.5V6.49995C7.5 5.25125 7.93782 4.18908 8.81345 3.31345C9.6891 2.43782 10.7513 2 12 2C13.2487 2 14.3108 2.43782 15.1865 3.31345C16.0621 4.18908 16.5 5.25125 16.5 6.49995V8.49995H17.6922C18.191 8.49995 18.6169 8.67656 18.9701 9.02977C19.3233 9.38297 19.5 9.80893 19.5 10.3077V19.6922C19.5 20.1909 19.3233 20.6169 18.9701 20.9701C18.6169 21.3233 18.191 21.4999 17.6922 21.4999H6.3077ZM6.3077 19.9999H17.6922C17.782 19.9999 17.8557 19.9711 17.9134 19.9134C17.9711 19.8557 18 19.7819 18 19.6922V10.3077C18 10.2179 17.9711 10.1442 17.9134 10.0865C17.8557 10.0288 17.782 9.99993 17.6922 9.99993H6.3077C6.21795 9.99993 6.14423 10.0288 6.08652 10.0865C6.02882 10.1442 5.99997 10.2179 5.99997 10.3077V19.6922C5.99997 19.7819 6.02882 19.8557 6.08652 19.9134C6.14423 19.9711 6.21795 19.9999 6.3077 19.9999ZM12 16.7499C12.4859 16.7499 12.899 16.5797 13.2394 16.2393C13.5798 15.899 13.75 15.4858 13.75 14.9999C13.75 14.514 13.5798 14.1009 13.2394 13.7605C12.899 13.4201 12.4859 13.25 12 13.25C11.5141 13.25 11.1009 13.4201 10.7606 13.7605C10.4202 14.1009 10.25 14.514 10.25 14.9999C10.25 15.4858 10.4202 15.899 10.7606 16.2393C11.1009 16.5797 11.5141 16.7499 12 16.7499ZM8.99997 8.49995H15V6.49995C15 5.66662 14.7083 4.95828 14.125 4.37495C13.5416 3.79162 12.8333 3.49995 12 3.49995C11.1666 3.49995 10.4583 3.79162 9.87497 4.37495C9.29164 4.95828 8.99997 5.66662 8.99997 6.49995V8.49995Z" fill="#0040FF" />
      </g>
    </svg>

  );
};
export const EyeIcon = ({ color }) => {
  const stroke = color ? color : 'black';
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4656_10609)">
        <path
          d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 12C19.333 16.667 16 19 12 19C8 19 4.667 16.667 2 12C4.667 7.333 8 5 12 5C16 5 19.333 7.333 22 12Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4656_10609">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const TickIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4656_18400)">
        <path
          d="M5 12L10 17L20 7"
          stroke="#00B335"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4656_18400">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const HidePasswordIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3091_23034)">
        <path
          d="M3 3L21 21"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5845 10.5869C10.2092 10.9619 9.99823 11.4707 9.99805 12.0012C9.99786 12.5317 10.2084 13.0406 10.5835 13.4159C10.9585 13.7912 11.4672 14.0021 11.9977 14.0023C12.5283 14.0025 13.0372 13.7919 13.4125 13.4169"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.357 17.3491C15.726 18.4491 13.942 19.0001 12 19.0001C8 19.0001 4.667 16.6671 2 12.0001C3.369 9.60506 4.913 7.82506 6.632 6.65906M9.363 5.36506C10.2204 5.11978 11.1082 4.9969 12 5.00006C16 5.00006 19.333 7.33306 22 12.0001C21.222 13.3611 20.388 14.5241 19.497 15.4881L9.363 5.36506Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3091_23034">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DeleteIcon = ({ color }) => {
  const stroke = color ? color : '#FF3300';
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3279_29610)">
        <path
          d="M4 7H20"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 11V17"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 11V17"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 7L6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19L19 7"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 7V4C9 3.73478 9.10536 3.48043 9.29289 3.29289C9.48043 3.10536 9.73478 3 10 3H14C14.2652 3 14.5196 3.10536 14.7071 3.29289C14.8946 3.48043 15 3.73478 15 4V7"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3279_29610">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const CopyIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3281_32410)">
        <path
          d="M18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8Z"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 8V6C16 5.46957 15.7893 4.96086 15.4142 4.58579C15.0391 4.21071 14.5304 4 14 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V14C4 14.5304 4.21071 15.0391 4.58579 15.4142C4.96086 15.7893 5.46957 16 6 16H8"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3281_32410">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PeoplesIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6043_17573" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6043_17573)">
        <path d="M4.99997 18.0423C5.89998 17.159 6.94581 16.4631 8.13748 15.9548C9.32914 15.4465 10.6166 15.1923 12 15.1923C13.3833 15.1923 14.6708 15.4465 15.8625 15.9548C17.0541 16.4631 18.1 17.159 19 18.0423V5.3077C19 5.23077 18.9679 5.16024 18.9038 5.09613C18.8397 5.03203 18.7692 4.99998 18.6923 4.99998H5.3077C5.23077 4.99998 5.16024 5.03203 5.09612 5.09613C5.03202 5.16024 4.99997 5.23077 4.99997 5.3077V18.0423ZM12 13.0385C12.9025 13.0385 13.6698 12.7224 14.3019 12.0904C14.9339 11.4583 15.25 10.691 15.25 9.78845C15.25 8.8859 14.9339 8.1186 14.3019 7.48655C13.6698 6.8545 12.9025 6.53848 12 6.53848C11.0974 6.53848 10.3301 6.8545 9.69808 7.48655C9.06603 8.1186 8.75 8.8859 8.75 9.78845C8.75 10.691 9.06603 11.4583 9.69808 12.0904C10.3301 12.7224 11.0974 13.0385 12 13.0385ZM5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.3077C3.5 4.80257 3.675 4.375 4.025 4.025C4.375 3.675 4.80257 3.5 5.3077 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80257 20.5 5.3077V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.3077ZM6.44225 19H17.5577V18.7885C16.768 18.0833 15.9016 17.5577 14.9587 17.2115C14.0157 16.8653 13.0295 16.6923 12 16.6923C10.9833 16.6923 10.0019 16.8637 9.05573 17.2067C8.10956 17.5497 7.2384 18.0705 6.44225 18.7692V19ZM12 11.5385C11.5192 11.5385 11.1073 11.367 10.7644 11.0241C10.4214 10.6811 10.25 10.2692 10.25 9.78845C10.25 9.30768 10.4214 8.89583 10.7644 8.55288C11.1073 8.20993 11.5192 8.03845 12 8.03845C12.4807 8.03845 12.8926 8.20993 13.2356 8.55288C13.5785 8.89583 13.75 9.30768 13.75 9.78845C13.75 10.2692 13.5785 10.6811 13.2356 11.0241C12.8926 11.367 12.4807 11.5385 12 11.5385Z" fill="black" fillOpacity="0.4" />
      </g>
    </svg>
  );
};
export const PeopleActiveIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6043_17573" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6043_17573)">
        <path d="M4.99997 18.0423C5.89998 17.159 6.94581 16.4631 8.13748 15.9548C9.32914 15.4465 10.6166 15.1923 12 15.1923C13.3833 15.1923 14.6708 15.4465 15.8625 15.9548C17.0541 16.4631 18.1 17.159 19 18.0423V5.3077C19 5.23077 18.9679 5.16024 18.9038 5.09613C18.8397 5.03203 18.7692 4.99998 18.6923 4.99998H5.3077C5.23077 4.99998 5.16024 5.03203 5.09612 5.09613C5.03202 5.16024 4.99997 5.23077 4.99997 5.3077V18.0423ZM12 13.0385C12.9025 13.0385 13.6698 12.7224 14.3019 12.0904C14.9339 11.4583 15.25 10.691 15.25 9.78845C15.25 8.8859 14.9339 8.1186 14.3019 7.48655C13.6698 6.8545 12.9025 6.53848 12 6.53848C11.0974 6.53848 10.3301 6.8545 9.69808 7.48655C9.06603 8.1186 8.75 8.8859 8.75 9.78845C8.75 10.691 9.06603 11.4583 9.69808 12.0904C10.3301 12.7224 11.0974 13.0385 12 13.0385ZM5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.3077C3.5 4.80257 3.675 4.375 4.025 4.025C4.375 3.675 4.80257 3.5 5.3077 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80257 20.5 5.3077V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.3077ZM6.44225 19H17.5577V18.7885C16.768 18.0833 15.9016 17.5577 14.9587 17.2115C14.0157 16.8653 13.0295 16.6923 12 16.6923C10.9833 16.6923 10.0019 16.8637 9.05573 17.2067C8.10956 17.5497 7.2384 18.0705 6.44225 18.7692V19ZM12 11.5385C11.5192 11.5385 11.1073 11.367 10.7644 11.0241C10.4214 10.6811 10.25 10.2692 10.25 9.78845C10.25 9.30768 10.4214 8.89583 10.7644 8.55288C11.1073 8.20993 11.5192 8.03845 12 8.03845C12.4807 8.03845 12.8926 8.20993 13.2356 8.55288C13.5785 8.89583 13.75 9.30768 13.75 9.78845C13.75 10.2692 13.5785 10.6811 13.2356 11.0241C12.8926 11.367 12.4807 11.5385 12 11.5385Z" fill="#0040FF" fillOpacity="1" />
      </g>
    </svg>
  );
};
export const PlusIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="white" />
      <g clipPath="url(#clip0_4769_24281)">
        <path
          d="M16 9V23"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 16H23"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#0040FF" />
      <defs>
        <clipPath id="clip0_4769_24281">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const List = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3784_37783)">
        <path
          d="M13 5H21"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 9H18"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 15H21"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 19H18"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 4H4C3.44772 4 3 4.44772 3 5V9C3 9.55228 3.44772 10 4 10H8C8.55228 10 9 9.55228 9 9V5C9 4.44772 8.55228 4 8 4Z"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 14H4C3.44772 14 3 14.4477 3 15V19C3 19.5523 3.44772 20 4 20H8C8.55228 20 9 19.5523 9 19V15C9 14.4477 8.55228 14 8 14Z"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3784_37783">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PlusSolidIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4849_21763)">
        <path
          d="M10 4.16699V15.8337"
          stroke="#0040FF"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.1665 10H15.8332"
          stroke="#0040FF"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4849_21763">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SearchBlack = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3784_42026)">
        <path
          d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 21L15 15"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3784_42026">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const EditIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3285_34096)">
        <path
          d="M9 7H6C5.46957 7 4.96086 7.21071 4.58579 7.58579C4.21071 7.96086 4 8.46957 4 9V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V15"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 15.0002H12L20.5 6.50023C20.8978 6.1024 21.1213 5.56284 21.1213 5.00023C21.1213 4.43762 20.8978 3.89805 20.5 3.50023C20.1022 3.1024 19.5626 2.87891 19 2.87891C18.4374 2.87891 17.8978 3.1024 17.5 3.50023L9 12.0002V15.0002Z"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 5L19 8"
          stroke="#0040FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3285_34096">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DateTimeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4938_8138)">
        <path
          d="M18 5H6C4.89543 5 4 5.89543 4 7V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V7C20 5.89543 19.1046 5 18 5Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 3V7"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 3V7"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 11H20"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 16H14"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4938_8138">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};


export const UploadIcon = ({ color }) => {
  const stroke = color ? color : 'black';
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4959_7558)">
        <path d="M4 17V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V17"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round" />
        <path d="M7 9L12 4L17 9" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 4V16" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_4959_7558">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}


export const OnlineCamera = () => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_3004_21255)">
        <rect x="8" y="4" width="48" height="48" rx="24" fill="white" />
        <path d="M33 19.25H27C23.58 19.25 22.25 20.58 22.25 24V32C22.25 34.3 23.5 36.75 27 36.75H33C36.42 36.75 37.75 35.42 37.75 32V24C37.75 20.58 36.42 19.25 33 19.25Z" fill="#0040FF" />
        <path d="M31.5001 27.38C32.5384 27.38 33.3801 26.5383 33.3801 25.5C33.3801 24.4617 32.5384 23.62 31.5001 23.62C30.4618 23.62 29.6201 24.4617 29.6201 25.5C29.6201 26.5383 30.4618 27.38 31.5001 27.38Z" fill="#ACFCCF" />
        <path opacity="0.7" d="M41.6505 22.17C41.2405 21.96 40.3805 21.72 39.2105 22.54L37.7305 23.58C37.7405 23.72 37.7505 23.85 37.7505 24V32C37.7505 32.15 37.7305 32.28 37.7305 32.42L39.2105 33.46C39.8305 33.9 40.3705 34.04 40.8005 34.04C41.1705 34.04 41.4605 33.94 41.6505 33.84C42.0605 33.63 42.7505 33.06 42.7505 31.63V24.38C42.7505 22.95 42.0605 22.38 41.6505 22.17Z" fill="#0040FF" />
      </g>
      <defs>
        <filter id="filter0_dd_3004_21255" x="0" y="0" width="64" height="64" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3004_21255" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_3004_21255" result="effect2_dropShadow_3004_21255" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3004_21255" result="shape" />
        </filter>
      </defs>
    </svg>

  )
}

export const OfflineCamera = () => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_3004_21280)">
        <rect x="8" y="4" width="48" height="48" rx="24" fill="white" />
        <path d="M37.65 22.56L24.2 36.01C22.8 35.12 22.25 33.53 22.25 32V24C22.25 20.58 23.58 19.25 27 19.25H33C35.89 19.25 37.29 20.2 37.65 22.56Z" fill="#0040FF" />
        <path d="M37.75 25.25V32C37.75 32.08 37.74 32.14 37.74 32.21C37.74 32.28 37.73 32.35 37.73 32.42H37.74C37.63 35.53 36.28 36.75 33 36.75H27C26.75 36.75 26.52 36.74 26.29 36.71L37.75 25.25Z" fill="#0040FF" />
        <path opacity="0.4" d="M37.7305 32.42C37.7305 32.35 37.7405 32.28 37.7405 32.21C37.7505 32.28 37.7505 32.35 37.7405 32.42H37.7305Z" fill="#FF3300" />
        <path opacity="0.4" d="M37.7405 23.5699C37.7505 23.6399 37.7505 23.7199 37.7405 23.7899C37.7405 23.7199 37.7305 23.6499 37.7305 23.5799L37.7405 23.5699Z" fill="#FF3300" />
        <path opacity="0.7" d="M42.7505 24.38V31.62C42.7505 33.05 42.0605 33.62 41.6505 33.83C41.4605 33.93 41.1705 34.04 40.8005 34.04C40.3705 34.04 39.8305 33.9 39.2105 33.46L37.7405 32.42H37.7305C37.7305 32.35 37.7405 32.28 37.7405 32.21C37.7405 32.14 37.7505 32.08 37.7505 32V25.25L41.0205 21.98C41.2905 22 41.5005 22.08 41.6505 22.17C42.0605 22.38 42.7505 22.95 42.7505 24.38Z" fill="#0040FF" />
        <path d="M41.7699 18.23C41.4699 17.93 40.9799 17.93 40.6799 18.23L22.2299 36.69C21.9299 36.99 21.9299 37.48 22.2299 37.78C22.3799 37.92 22.5699 38 22.7699 38C22.9699 38 23.1599 37.92 23.3099 37.77L41.7699 19.31C42.0799 19.01 42.0799 18.53 41.7699 18.23Z" fill="#FF3300" />
      </g>
      <defs>
        <filter id="filter0_dd_3004_21280" x="0" y="0" width="64" height="64" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3004_21280" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_3004_21280" result="effect2_dropShadow_3004_21280" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3004_21280" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}
export const CheckSuccesIcon = () => {
  return (
    <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.66675 9.99967L9.33341 16.6663L22.6667 3.33301" stroke="white" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const BackIcon = () => {
  return (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 1L1 7L7 13" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const ListIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4215_43518)">
        <path d="M13 5H21" stroke="#0040FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13 9H18" stroke="#0040FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13 15H21" stroke="#0040FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13 19H18" stroke="#0040FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 4H4C3.44772 4 3 4.44772 3 5V9C3 9.55228 3.44772 10 4 10H8C8.55228 10 9 9.55228 9 9V5C9 4.44772 8.55228 4 8 4Z" stroke="#0040FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 14H4C3.44772 14 3 14.4477 3 15V19C3 19.5523 3.44772 20 4 20H8C8.55228 20 9 19.5523 9 19V15C9 14.4477 8.55228 14 8 14Z" stroke="#0040FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_4215_43518">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}



export const CreditCartIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3778_39248)">
        <path d="M18 5H6C4.34315 5 3 6.34315 3 8V16C3 17.6569 4.34315 19 6 19H18C19.6569 19 21 17.6569 21 16V8C21 6.34315 19.6569 5 18 5Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3 10H21" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 15H7.01" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11 15H13" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_3778_39248">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const SmallZoomIcon = ({ color = "white" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4472_13435)">
        <path
          d="M18 10H14V6"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 4L14 10"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 14H10V18"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 14L4 20"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4472_13435">
          <rect width="24" height="24" fill="black" />
        </clipPath>
      </defs>
    </svg>
  );
};


export const ActiveTime = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6043_17568" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6043_17568)">
        <path d="M12 21.5C10.6858 21.5 9.45082 21.2506 8.295 20.752C7.13917 20.2533 6.13375 19.5765 5.27875 18.7217C4.42375 17.8669 3.74688 16.8616 3.24812 15.706C2.74937 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74938 15.7034 3.24813C16.8596 3.74688 17.8652 4.42375 18.7205 5.27875C19.5757 6.13375 20.2527 7.13917 20.7516 8.295C21.2505 9.45082 21.5 10.6858 21.5 12C21.5 12.45 21.4717 12.8916 21.4153 13.325C21.3589 13.7583 21.2692 14.1833 21.1461 14.6C20.9641 14.4102 20.7589 14.2478 20.5307 14.1125C20.3025 13.9772 20.0532 13.8827 19.7827 13.8289C19.8583 13.534 19.9134 13.2349 19.9481 12.9317C19.9827 12.6285 20 12.3179 20 12C20 9.76664 19.225 7.87498 17.675 6.32498C16.125 4.77498 14.2333 3.99998 12 3.99998C9.76664 3.99998 7.87498 4.77498 6.32498 6.32498C4.77498 7.87498 3.99998 9.76664 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20C12.8756 20 13.7089 19.8682 14.4997 19.6047C15.2905 19.3412 16.0175 18.9723 16.6808 18.4981C16.8359 18.7045 17.0176 18.8903 17.2259 19.0557C17.4343 19.2211 17.6602 19.3525 17.9038 19.45C17.0923 20.0948 16.188 20.5977 15.1911 20.9586C14.1941 21.3195 13.1304 21.5 12 21.5ZM19.1063 17.75C18.8264 17.75 18.5897 17.6533 18.3961 17.4601C18.2025 17.2669 18.1058 17.0304 18.1058 16.7505C18.1058 16.4707 18.2024 16.234 18.3956 16.0404C18.5888 15.8468 18.8254 15.75 19.1052 15.75C19.385 15.75 19.6217 15.8466 19.8153 16.0398C20.0089 16.2331 20.1057 16.4696 20.1057 16.7494C20.1057 17.0293 20.0091 17.266 19.8159 17.4596C19.6227 17.6532 19.3861 17.75 19.1063 17.75ZM15.4731 16.5269L11.25 12.3036V6.99998H12.75V11.6961L16.5269 15.4731L15.4731 16.5269Z" fill="#0040FF" fillOpacity="1" />
      </g>
    </svg>
  )
}


export const TimeIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6043_17568" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6043_17568)">
        <path d="M12 21.5C10.6858 21.5 9.45082 21.2506 8.295 20.752C7.13917 20.2533 6.13375 19.5765 5.27875 18.7217C4.42375 17.8669 3.74688 16.8616 3.24812 15.706C2.74937 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74938 15.7034 3.24813C16.8596 3.74688 17.8652 4.42375 18.7205 5.27875C19.5757 6.13375 20.2527 7.13917 20.7516 8.295C21.2505 9.45082 21.5 10.6858 21.5 12C21.5 12.45 21.4717 12.8916 21.4153 13.325C21.3589 13.7583 21.2692 14.1833 21.1461 14.6C20.9641 14.4102 20.7589 14.2478 20.5307 14.1125C20.3025 13.9772 20.0532 13.8827 19.7827 13.8289C19.8583 13.534 19.9134 13.2349 19.9481 12.9317C19.9827 12.6285 20 12.3179 20 12C20 9.76664 19.225 7.87498 17.675 6.32498C16.125 4.77498 14.2333 3.99998 12 3.99998C9.76664 3.99998 7.87498 4.77498 6.32498 6.32498C4.77498 7.87498 3.99998 9.76664 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20C12.8756 20 13.7089 19.8682 14.4997 19.6047C15.2905 19.3412 16.0175 18.9723 16.6808 18.4981C16.8359 18.7045 17.0176 18.8903 17.2259 19.0557C17.4343 19.2211 17.6602 19.3525 17.9038 19.45C17.0923 20.0948 16.188 20.5977 15.1911 20.9586C14.1941 21.3195 13.1304 21.5 12 21.5ZM19.1063 17.75C18.8264 17.75 18.5897 17.6533 18.3961 17.4601C18.2025 17.2669 18.1058 17.0304 18.1058 16.7505C18.1058 16.4707 18.2024 16.234 18.3956 16.0404C18.5888 15.8468 18.8254 15.75 19.1052 15.75C19.385 15.75 19.6217 15.8466 19.8153 16.0398C20.0089 16.2331 20.1057 16.4696 20.1057 16.7494C20.1057 17.0293 20.0091 17.266 19.8159 17.4596C19.6227 17.6532 19.3861 17.75 19.1063 17.75ZM15.4731 16.5269L11.25 12.3036V6.99998H12.75V11.6961L16.5269 15.4731L15.4731 16.5269Z" fill="black" fillOpacity="0.4" />
      </g>
    </svg>
  )
}


export const ErrorIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#F25B60" fillOpacity="0.1" />
      <rect x="3" y="3" width="18" height="18" rx="9" fill="#FF3300" />
      <g clipPath="url(#clip0_5479_38918)">
        <path d="M12 8V12" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 15H12.01" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5479_38918">
          <rect width="12" height="12" fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const CloseIcon = ({ color }) => {
  const stroke = color ? color : 'black';
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="black" fillOpacity="0.05" />
      <rect x="3" y="3" width="18" height="18" rx="9" fill="black" fillOpacity="0.4" />
      <g clipPath="url(#clip0_5479_39072)">
        <path d="M15 9L9 15" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 9L15 15" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5479_39072">
          <rect width="12" height="12" fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const ProtectIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#0040FF" fillOpacity="0.1" />
      <mask id="mask0_5479_38934" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="3" y="3" width="18" height="18">
        <rect x="3" y="3" width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5479_38934)">
        <path d="M12 19.5C10.2625 19.0625 8.82825 18.0655 7.69725 16.509C6.56575 14.953 6 13.225 6 11.325V6.75L12 4.5L18 6.75V11.325C18 13.225 17.4345 14.953 16.3035 16.509C15.172 18.0655 13.7375 19.0625 12 19.5Z" fill="url(#paint0_linear_5479_38934)" />
      </g>
      <defs>
        <linearGradient id="paint0_linear_5479_38934" x1="12" y1="4.5" x2="12" y2="19.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4775FF" />
          <stop offset="1" stopColor="#0040FF" />
        </linearGradient>
      </defs>
    </svg >

  )
}

export const SuccessIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#32D022" fillOpacity="0.1" />
      <rect x="4" y="4" width="24" height="24" rx="12" fill="url(#paint0_linear_5520_9234)" />
      <g clipPath="url(#clip0_5520_9234)">
        <path d="M11.3333 15.9998L14.6666 19.3332L21.3333 12.6665" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <linearGradient id="paint0_linear_5520_9234" x1="10" y1="4.9" x2="25.9" y2="30.1" gradientUnits="userSpaceOnUse">
          <stop stopColor="#45DC36" />
          <stop offset="1" stopColor="#18BB46" />
        </linearGradient>
        <clipPath id="clip0_5520_9234">
          <rect width="16" height="16" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const GotoMore = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5480_38121)">
        <path d="M11 7H6C5.46957 7 4.96086 7.21071 4.58579 7.58579C4.21071 7.96086 4 8.46957 4 9V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V13" stroke="#0040FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 14L20 4" stroke="#0040FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 4H20V9" stroke="#0040FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5480_38121">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const HintIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5533_43179)">
        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="black" fillOpacity="0.4" />
        <path d="M12 8H12.01" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11 12H12V16H13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5533_43179">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const OnStatus = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.15" cx="8" cy="8" r="8" fill="#0040FF" />
      <circle cx="8" cy="8" r="4" fill="#0040FF" />
    </svg>
  )
}

export const OffStatus = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.15" cx="8" cy="8" r="8" fill="#FF3300" />
      <circle cx="8" cy="8" r="4" fill="#FF3300" />
    </svg>
  )
}
export const WeakStatus = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.15" cx="8" cy="8" r="8" fill="#ff8d00" />
      <circle cx="8" cy="8" r="4" fill="#ff8d00" />
    </svg>
  )
}
export const LoseConnectStatus = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.15" cx="8" cy="8" r="8" fill="yellow" />
      <circle cx="8" cy="8" r="4" fill="yellow" />
    </svg>
  )
}

export const WeakConnectStatus = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.15" cx="8" cy="8" r="8" fill="orange" />
      <circle cx="8" cy="8" r="4" fill="orange" />
    </svg>
  )
}

export const OnStatusGreen = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.15" cx="8" cy="8" r="8" fill="#00B335" />
      <circle cx="8" cy="8" r="4" fill="#00B335" />
    </svg>
  )
}

export const PreviousWhite = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4578_20418)">
        <path
          d="M15.5 6L9.5 12L15.5 18"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4578_20418">
          <rect
            width="24"
            height="24"
            fill="black"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NextWhite = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4578_20446)">
        <path
          d="M9.5 18L15.5 12L9.5 6"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4578_20446">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(24.5 24) rotate(-180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SquareIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5826_28274)">
        <path d="M4.16667 5.83333C5.08714 5.83333 5.83333 5.08714 5.83333 4.16667C5.83333 3.24619 5.08714 2.5 4.16667 2.5C3.24619 2.5 2.5 3.24619 2.5 4.16667C2.5 5.08714 3.24619 5.83333 4.16667 5.83333Z" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.8337 5.83333C16.7541 5.83333 17.5003 5.08714 17.5003 4.16667C17.5003 3.24619 16.7541 2.5 15.8337 2.5C14.9132 2.5 14.167 3.24619 14.167 4.16667C14.167 5.08714 14.9132 5.83333 15.8337 5.83333Z" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.16667 17.4998C5.08714 17.4998 5.83333 16.7536 5.83333 15.8332C5.83333 14.9127 5.08714 14.1665 4.16667 14.1665C3.24619 14.1665 2.5 14.9127 2.5 15.8332C2.5 16.7536 3.24619 17.4998 4.16667 17.4998Z" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.8337 17.4998C16.7541 17.4998 17.5003 16.7536 17.5003 15.8332C17.5003 14.9127 16.7541 14.1665 15.8337 14.1665C14.9132 14.1665 14.167 14.9127 14.167 15.8332C14.167 16.7536 14.9132 17.4998 15.8337 17.4998Z" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.16699 5.8335V14.1668" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.83301 4.1665H14.1663" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.83301 15.8335H14.1663" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.833 5.8335V14.1668" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5826_28274">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const RefreshIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5826_28263)">
        <path d="M16.6663 9.16658C16.4625 7.7001 15.7822 6.3413 14.7302 5.2995C13.6782 4.25769 12.3128 3.59068 10.8444 3.40121C9.376 3.21174 7.88603 3.51032 6.60401 4.25096C5.32199 4.99159 4.31905 6.1332 3.74967 7.49992M3.33301 4.16658V7.49992H6.66634" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.33301 10.8335C3.53681 12.3 4.21712 13.6588 5.26914 14.7006C6.32117 15.7424 7.68654 16.4094 9.15495 16.5989C10.6234 16.7883 12.1133 16.4898 13.3953 15.7491C14.6774 15.0085 15.6803 13.8669 16.2497 12.5002M16.6663 15.8335V12.5002H13.333" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5826_28263">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const RestoreIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5826_28286)">
        <path d="M16.2079 12.4999C16.5362 11.6846 16.7007 10.8127 16.6921 9.93379C16.6834 9.05492 16.5017 8.18637 16.1573 7.37773C15.813 6.56908 15.3127 5.83618 14.6851 5.22087C14.0575 4.60556 13.3149 4.11989 12.4996 3.79158C10.853 3.12854 9.01054 3.14675 7.37741 3.84219C5.74428 4.53764 4.4543 5.85336 3.79126 7.49992M7.4996 7.49992L3.33293 7.49992L3.33293 3.33325" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.0332 15.3081L14.0249 15.3081" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.38379 10.8335L3.37546 10.8335" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.69141 14.0332L4.68307 14.0332" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.41699 16.1416L7.40866 16.1416" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.833 16.6167L10.8247 16.6167" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5826_28286">
          <rect width="20" height="20" fill="white" transform="translate(20) rotate(90)" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const NextIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5826_28295)">
        <path d="M3.79207 12.4999C3.46377 11.6846 3.29926 10.8127 3.30794 9.93379C3.31663 9.05492 3.49833 8.18637 3.84268 7.37773C4.18703 6.56908 4.68729 5.83618 5.31488 5.22087C5.94247 4.60556 6.68511 4.11989 7.5004 3.79158C9.14696 3.12854 10.9895 3.14675 12.6226 3.84219C14.2557 4.53764 15.5457 5.85336 16.2087 7.49992M12.5004 7.49992L16.6671 7.49992L16.6671 3.33325" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.9668 15.3081L5.97513 15.3081" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.6162 10.8335L16.6245 10.8335" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.3086 14.0332L15.3169 14.0332" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.583 16.1416L12.5913 16.1416" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.16699 16.6167L9.17533 16.6167" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5826_28295">
          <rect width="20" height="20" fill="white" transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 0)" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const CloseShape = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="8" fill="#FF3300" />
      <g clipPath="url(#clip0_5838_28317)">
        <path d="M10.5 5.5L5.5 10.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.5 5.5L10.5 10.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5838_28317">
          <rect width="10" height="10" fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const CheckIcon = () => {
  return (
    <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 6L6 11L16 1" stroke="#1AB60B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}

export const HomeIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6059_17538" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6059_17538)">
        <path d="M4.5 18.4996V7.24967L12 1.60547L19.5 7.24967V11.4131H18V7.99964L12 3.48042L5.99997 7.99964V16.9996H12.4135V18.4996H4.5ZM18.5 21.3938L17.2923 18.7073L14.6058 17.4996L17.2923 16.292L18.5 13.6055L19.7077 16.292L22.3941 17.4996L19.7077 18.7073L18.5 21.3938Z" fill="black" fillOpacity={'0.4'} />
      </g>
    </svg>

  )
}

export const HomeIconActive = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6059_17538" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6059_17538)">
        <path d="M4.5 18.4996V7.24967L12 1.60547L19.5 7.24967V11.4131H18V7.99964L12 3.48042L5.99997 7.99964V16.9996H12.4135V18.4996H4.5ZM18.5 21.3938L17.2923 18.7073L14.6058 17.4996L17.2923 16.292L18.5 13.6055L19.7077 16.292L22.3941 17.4996L19.7077 18.7073L18.5 21.3938Z" fill="#0040FF" />
      </g>
    </svg>
  )
}
export const SupportIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z" fill="black" fillOpacity="0.4" />
    </svg>
  );
};

export const TicketIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 17H13V13H17V11H13V7H11V11H7V13H11V17ZM5 21C4.45 21 3.979 20.804 3.587 20.412C3.195 20.02 2.99934 19.5493 3 19V5C3 4.45 3.196 3.979 3.588 3.587C3.98 3.195 4.45067 2.99934 5 3H19C19.55 3 20.021 3.196 20.413 3.588C20.805 3.98 21.0007 4.45067 21 5V19C21 19.55 20.804 20.021 20.412 20.413C20.02 20.805 19.5493 21.0007 19 21H5ZM5 19H19V5H5V19Z" fill="black" fillOpacity="0.4" />
    </svg>
  );
};

export { default as ExcelIcon } from './CameraControl/ExcelIcon'
export { default as TakePhotoIcon } from './TakePhotoIcon'
export { default as Alpr } from './Dashboard/Alpr'
export { default as FireIcon } from './Dashboard/FireIcon'
export { default as FaceIcon } from './Dashboard/FaceIcon'
